/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import SelectInput from 'components/input/SelectInput';
import { getDaysInMonth, getMonthIndex } from 'components/helper/datetime.helper';
import { monthOptions, dayOptions } from 'components/helper/helper';
import { receivedYears } from './education.config';
import Grid from '@mui/joy/Grid';

type Props = {
  formik: any;
  check?: any;
  disabled?: boolean;
};

const DateReceiveInfo = ({ formik, check, disabled }: Props) => {
  const [receivedDays, setRecievedDays] = React.useState<any[]>(dayOptions);
  const defaultYear = 2000;

  const receivedDateChane = (e: any, type: string) => {
    try {
      let month = getMonthIndex(formik.values.month); // base 0
      let year = Number(formik.values.year);
      let day = formik.values.day ?? '1';
      let days = getDaysInMonth(month, defaultYear);

      switch (type) {
        case 'year':
          year = Number(e.target.value);
          break;
        case 'month':
          if (e==='' || e=== '- Select -') {
            formik.setFieldValue('day', '');
            return;
          }
          month = getMonthIndex(e.target.value);
          break;
        case 'day':
          day = e.target.value;
          break;
      }

      if (Number.isNaN(year)) {
        year = defaultYear;
      }

     
      days = getDaysInMonth(month, year);
      setRecievedDays(days);

      if (Number.isNaN(formik.values.day)) {
        formik.setFieldValue('day', '');
        return;
      }

      if (!(day in days)) {
        formik.setFieldValue('day', days[days.length - 1]);
      }
    } catch (ex) {}

    formik.handleChange(e);
  };

  return (
    <>
      <div className="text-field-light mt-3">Date received or to be received</div>
      <Grid container spacing={2} className="gm-form-fields">
        <Grid xs={12} md={4}>
          <SelectInput
            form={formik}
            option={monthOptions}
            label="Month*"
            values={formik.values.month}
            name="month"
            onChange={(e: any) => receivedDateChane(e, 'month')}
            isMissing={
              (!formik.values.month ||
               formik.values.month === '- Select -' ||
               formik.values.month === '') && check
            }
            disabled={disabled}
          />
        </Grid>
        <Grid xs={12} md={4}>
          <SelectInput
            form={formik}
            option={receivedDays}
            label="Day*"
            values={formik.values.day}
            name="day"
            onChange={(e: any) => receivedDateChane(e, 'day')}
            isMissing={
              (!formik.values.day ||
               formik.values.day === '- Select -' ||
               formik.values.day === '') && check
            }
            disabled={disabled}
          />
        </Grid>
        <Grid xs={12} md={4}>
          <SelectInput
            form={formik}
            option={receivedYears}
            label="Year*"
            values={formik.values.year}
            name="year"
            onChange={(e: any) => receivedDateChane(e, 'year')}
            isMissing={
              (!formik.values.year ||
               formik.values.year === '- Select -' ||
               formik.values.year === '') && check
            }
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DateReceiveInfo;
